"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListKeyboardNavigation = void 0;
var useListKeyboardNavigation = function (configuration) {
    var onKeyDown = function (e) {
        if (configuration.disabled) {
            return;
        }
        switch (e.key) {
            case "ArrowDown":
            // Fall through
            case "ArrowUp":
                /**
                 * preventDefault stops the cursor from moving to the start/
                 * end of the text box when using the arrow keys.
                 */
                e.preventDefault();
                configuration.onArrowNavigation(e.key, e);
                break;
            case " ": // The space key
                /**
                 * If there is a text input active, space shouldn't select the
                 * highlighted option as the user may just want to add a space
                 * to the search query.
                 */
                if (configuration.textInputActive) {
                    configuration.onActivationKeyPress(e);
                    // Don't fall through (skips selection behaviour)
                    break;
                    /**
                     * If the space key is pressed and there is no text input
                     * active, then fall through to "Enter" behaviour 👇
                     */
                }
            case "Enter":
                e.preventDefault();
                configuration.onActivationKeyPress(e);
                break;
            case "Backspace":
                configuration.onRemoveKeyPress(e);
                break;
            case "Tab":
                configuration.onActivationKeyPress(e);
                configuration.onNavigationAway(e);
                break;
            default:
                configuration.onUnhandledKeyPress(e);
        }
    };
    return {
        onKeyDown: onKeyDown,
    };
};
exports.useListKeyboardNavigation = useListKeyboardNavigation;
//# sourceMappingURL=useListKeyboardNavigation.js.map